/* istanbul ignore file */
import { css } from 'styled-components';

const WITH_TRANSFORM_CSS = css`
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: 0 0;
`;

export const iconWrapper = css`
  display: block;
  pointer-events: none;
  align-self: center;
  vertical-align: middle;
`;

export const icon = css`
  ${
    /* Reason for up-sizing and scaling down with scale(0.5): https://stackoverflow.com/a/63189810 */ ''
  }
  ${WITH_TRANSFORM_CSS};
  display: block;
  pointer-events: none;
  background-size: 100%;
  mask-image: var(--iconImage);
  background-color: var(--iconColor, var(--neutral-black-base));
  mask-size: cover;
  vertical-align: middle;
`;
